import { render } from "./ListUserSelf.vue?vue&type=template&id=b9fbe5ae&scoped=true"
import script from "./ListUserSelf.vue?vue&type=script&lang=js"
export * from "./ListUserSelf.vue?vue&type=script&lang=js"

import "./ListUserSelf.vue?vue&type=style&index=0&id=b9fbe5ae&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9fbe5ae"]])

export default __exports__